<script setup lang="ts">
import { IconAlertCircle, IconInfoCircle } from '@tabler/icons-vue';
import { computed } from 'vue';

import { FinancingFlowApi } from '~/services/financing-flow-api/financing-flow.types';
import date from '~/utils/date';

interface Props {
  financing: { data: FinancingFlowApi.FinancingV2 };
}

const props = defineProps<Props>();

const cancelationReasonLabels = {
  client_requested: 'Cancelamento solicitado pelo cliente',
  risk_fraud: 'Fraude comprovada',
  risk_suspected: 'Suspeita de Fraude',
} as const;

const isRiskOtherReason = computed(() => props.financing.data.reason?.includes('risk_other') ?? false);

const cancelationReasonText = computed(() => {
  if (!props.financing.data.reason) return '';

  if (isRiskOtherReason.value) {
    return props.financing.data.reason.split('risk_other_')[1] || '';
  }

  return cancelationReasonLabels[props.financing.data.reason as keyof typeof cancelationReasonLabels]
    || props.financing.data.reason;
});
</script>

<template>
  <div v-permission="['cancel_project:view']">
    <div v-if="financing.data.status === 'canceled'" class="alert alert-danger mb-4" role="alert">
      <div class="alert-icon">
        <IconAlertCircle :size="24" :stroke-width="2" class="icon alert-icon icon-2" />
      </div>
      <div>
        <h4 class="alert-heading">Projeto cancelado</h4>
        <div v-if="financing.data.reason" class="alert-description">
          <span> Motivo do cancelamento: </span>
          <span class="fw-bold">
            {{ cancelationReasonText }}{{ isRiskOtherReason ? '' : '.' }}
          </span>
        </div>
      </div>
    </div>
    <template v-else>
      <div
        v-if="financing.data.installed_at"
        class="alert alert-info mb-4"
        role="alert"
      >
        <div class="alert-icon">
          <IconInfoCircle :size="24" :stroke-width="2" class="icon alert-icon icon-2" />
        </div>
        <div>
          <h4 class="alert-heading">Cancelamento indisponível</h4>
          <div class="alert-description">
            <span> O projeto foi instalado </span>
            {{ date(financing.data.installed_at).format('LLLL') }},
            logo o cancelamento não é permitido via backoffice.
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
